import styled from 'styled-components'
import ArrowBackSvg from '~components/svgs/ArrowBack'
import CloseSvg from '~components/svgs/Close'
import FretebrasLogoSvg from '~components/svgs/FretebrasLogo'

export const Close = styled(CloseSvg).attrs({
  height: 18,
  width: 18,
  viewBox: '0 0 14 14',
})`
  cursor: pointer;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translate(calc(-100% - 280px), -50%);

  @media (max-width: ${({ theme }) => theme.breakpoint.lg.maxWidth}) {
    transform: translate(calc(-100% - 180px), -50%);
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    transform: translate(calc(-100% - 80px), -50%);
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    transform: translate(calc(-100% - ${({ theme }) => theme.spacing.km4}), -50%);
  }
`

export const ArrowBack = styled(ArrowBackSvg)`
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(280px, -50%);

  @media (max-width: ${({ theme }) => theme.breakpoint.lg.maxWidth}) {
    transform: translate(180px, -50%);
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    transform: translate(80px, -50%);
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    transform: translate(${({ theme }) => theme.spacing.km4}, -50%);
  }
`

export const Logo = styled(FretebrasLogoSvg)`
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
`

export const Header = styled.div`
  height: 80px;
  background: ${({ theme }) => theme.neutral.background.default};
  position: relative;
  box-shadow: 0px 2px 4px -2px rgba(38, 47, 74, 0.12),
    0px 4px 4px -2px rgba(38, 47, 74, 0.08);

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    height: 62px;
  }
`
